/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProcessStateEnum } from './processStateEnum';
import { StatusCodeEnum } from './statusCodeEnum';
import { UserChannelTypeEnum } from './userChannelTypeEnum';

export interface TransactionLogModel { 
    id?: string;
    transactionId?: string;
    messageId?: string;
    destinationNumber?: string;
    originatingNumber?: string;
    serviceProviderId?: string;
    messageContent?: string;
    dateTimeCreated?: Date;
    processElapedTime?: number;
    statusCode?: StatusCodeEnum;
    readonly statusDescription?: string;
    processState?: ProcessStateEnum;
    senderId?: string;
    totalElapedTime?: string;
    userChannelType?: UserChannelTypeEnum;
    routeId?: string;
}